import SitebarDropdown from './sitebarDropdown';
import i18n from 'src/utils/translate';
import styled from 'styled-components';
import { textLinkSecondary } from 'styles-js/mixins/typography';
import { LinkButton } from 'styles-js/buttons';
import { useSelector } from 'react-redux';
import { State } from 'src/types';
import MoreList from './moreList';
import Avatar from '../avatar';

export default function UserMenu({open, handleClick}) {

  const { currentUser } = useSelector(({context}: State) => context);

  return (
    <div data-test-id="user-menu">
      <UserMenuButton onClick={handleClick}>
        <Avatar alt="Your avatar" size="xsmall" src={currentUser.avatarImageUrl} />
        {i18n.t('More')}
      </UserMenuButton>
      <SitebarDropdown marginLeft={-167} open={open} width={215}>
        <MoreList />
      </SitebarDropdown>
    </div>
  );
}

const UserMenuButton = styled(LinkButton)`
  ${textLinkSecondary};
  font-family: ${({theme}) => theme.fontFamilyTitle};
  line-height: 49px;
  display: flex;
  align-items: center;
  margin-left: 15px;

  &:focus, &:hover, &:active {
    color: ${({theme}) => theme.colorBlack};
  }

  img {
    margin-right: 5px;
  }
`;
